import { observable } from 'mobx';

class AllPaneStore {
  @observable isArchivesChecked = false;
}

export default AllPaneStore;
